import { notifyError } from 'components/notification';
import { useModalControls } from 'context/ModalContext';
import { useWithAuthentication } from 'hooks/useWithAuthentication';
import { useMemo } from 'react';
import { useTldlActions } from '../state/tldl';
import useTldlView from '../state/useTldlView';
import useValidateTldlEpisode from '../state/useValidateTldlEpisode';

/**
 * Opens TLDL search only when allowed.
 *
 * The user can only search for and add podcasts when in the "landing" or
 * "selection" views.
 *
 * This hook also handles the response data from the search modal.
 */
export default function useOpenTldlSearch() {
  const { createAuthenticatedHandler } = useWithAuthentication();
  const { open: openModal } = useModalControls();
  const { validateEpisode } = useValidateTldlEpisode();
  const { addEpisode } = useTldlActions();
  const view = useTldlView();

  return {
    openTldlSearch: useMemo(
      () =>
        createAuthenticatedHandler(() => {
          if (view !== 'landing' && view !== 'selection') {
            return;
          }

          openModal({
            name: 'TldlSearch',
            params: {
              onSelectEpisode(episode) {
                validateEpisode(episode, {
                  onFailure: (_, reason) => {
                    const heading = 'Sorry, this podcast cannot be added';
                    if (reason === 'blocked') {
                      notifyError({
                        heading,
                        subHeading:
                          "The creator of this podcast has requested that it isn't " +
                          'eligible for TLDL. Contact us at support@headliner.app for more info.',
                      });
                    } else {
                      notifyError({ heading });
                    }
                  },
                  onSuccess: (e) => {
                    addEpisode(e);
                  },
                });
              },
            },
          });
        }),
      [
        addEpisode,
        createAuthenticatedHandler,
        openModal,
        validateEpisode,
        view,
      ],
    ),
  };
}
